import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { gaWidgetDataAutomation } from "app/pages/activation/components/GAWidget/dataAutomationKeys";

import type { GAGraphData } from "../../../types/api";
import type { BenchmarkGranularity } from "../../../types/common";
import type { ConfigSchema, PieChartDataSchema } from "../types";
import Widget from "../Widget/Widget";

import * as SC from "./styles";

type SortableWidgetSchema = {
    id: string;
    index: number;
    metricName: string;
    isConnected: boolean;
    isLoading: boolean;
    isSwSource?: boolean;
    data: GAGraphData | PieChartDataSchema;
    granularity: BenchmarkGranularity;
    withBorder?: boolean;
    onClick?: () => void;
} & ConfigSchema;

const SortableWidget = ({ id, index, metricName, ...widgetProps }: SortableWidgetSchema) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <SC.DraggableWrapper
            ref={setNodeRef}
            style={style}
            isDragging={isDragging}
            data-automation={gaWidgetDataAutomation.draggableWidget}
            {...attributes}
            {...listeners}
        >
            <SC.DraggableIcon
                iconName="drag-indicator"
                size="xs"
            />
            <Widget
                metricName={metricName}
                {...widgetProps}
            />
        </SC.DraggableWrapper>
    );
};

export default SortableWidget;
